import React from 'react'

import { DeltaValue } from '@/shared/components/ui/delta-value'

import { BasicNumberField } from './BasicNumberField'

export function BasicDeltaField(props: { value: number | null | undefined }) {
	return (
		<DeltaValue value={props.value}>
			<BasicNumberField {...props} />
		</DeltaValue>
	)
}
